import script from "./ShopCartView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopCartView.vue?vue&type=script&lang=ts&setup=true"

import "./ShopCartView.vue?vue&type=style&index=0&id=3253dc0b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3253dc0b"]])

export default __exports__